import React from 'react';
import { motion } from 'framer-motion';
import { BrainIcon, CreditCardIcon, LockIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { heroImage } from '../data/content';
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section className="w-full bg-white pb-16 pt-12 md:pb-24 md:pt-16" data-id="element-128" data-mp="4lywsqa2emfr">
      <div className="mx-auto w-full max-w-content px-5 text-center md:px-8" data-id="element-129" data-mp="4jvvvb7dj8w9">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        ease
      }} className="inline-flex items-center gap-2 font-display text-base font-extrabold uppercase tracking-[0.16em] text-blue-600 md:text-lg" data-id="element-130" data-mp="128pixfs3x15m">
          <BrainIcon className="h-5 w-5" aria-hidden="true" data-id="element-131" data-mp="nbyid36p5jef" />
          MiMejorVersión™
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.05,
        ease
      }} className="mx-auto mt-6 max-w-4xl font-display text-[2.75rem] font-extrabold leading-[1.02] tracking-tight text-ink sm:text-6xl md:text-7xl" data-id="element-132" data-mp="3czfkfwx3o34z">
          Su mente fuerte.
          <br data-id="element-133" data-mp="39b4gcyqfxq1v" />
          <span className="text-blue-600" data-id="element-134" data-mp="399jmlbbyab52">Lista. Desde hoy.</span>
        </motion.h1>

        <motion.img initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.12,
        ease
      }} src={heroImage} alt="MegaPack Método Mente Viva: caja, los 6 tomos, láminas de ejercicios y tarjetas de conexión" className="mx-auto mt-10 w-full max-w-xl" width={1240} height={1240} data-id="element-135" data-mp="3e8mqgsg72bbg" />

        <motion.div initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.45,
        delay: 0.18,
        ease
      }} className="mx-auto mt-10 max-w-3xl" data-id="element-136" data-mp="2vjpzaxg3fyxg">
          <p className="font-display text-2xl font-extrabold leading-snug tracking-tight text-blue-600 md:text-3xl" data-id="element-137" data-mp="2ljz5yz39rpyy">
            El sistema N°1 para estimulación cognitiva en adultos mayores
          </p>
          <p className="mt-5 text-xl leading-relaxed text-ink md:text-2xl" data-id="element-138" data-mp="n98ebq63t9oy">
            200 ejercicios + 3 bonos. Todo listo. Sin armarlo.
          </p>

          <div className="mt-10" data-id="element-139" data-mp="ddwz76qsa0go">
            <CtaButton size="xl" className="w-full max-w-2xl" data-id="element-140" data-mp="deyitzlv7va0">
              Quiero mi Método Mente Viva ahora
            </CtaButton>
          </div>

          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-7 gap-y-2 text-sm font-medium text-blue-900/70" data-id="element-141" data-mp="161b0fh1ili6l">
            <li className="inline-flex items-center gap-1.5" data-id="element-142" data-mp="111eqz2a1syjn">
              <ShieldCheckIcon className="h-4 w-4 text-mint-500" aria-hidden="true" data-id="element-143" data-mp="x1nv4k5nzs89" /> Garantía 7 días
            </li>
            <li className="inline-flex items-center gap-1.5" data-id="element-144" data-mp="3lu04x6yc5f2d">
              <LockIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-145" data-mp="3hrd9yx6dbe0y" /> Pago seguro
            </li>
            <li className="inline-flex items-center gap-1.5" data-id="element-146" data-mp="1x9kugm9v74h7">
              <CreditCardIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-147" data-mp="1xb5ped03cpfl" /> Mercado Pago
            </li>
          </ul>
        </motion.div>
      </div>
    </section>;
}